/**
 * Legend under the Forecast grid — Open PO first, then Forecast, then Total.
 *
 * The Total entry is listed only when the grid renders Total rows (the reviewed tenant
 * review 11 Sep, review item 35c: the legend named a row the grid did not show).
 */
import { StockStatusLegend } from '../../StockStatusIndicator';

interface ForecastLegendProps {
  showTotalRow: boolean;
  showStockStatus: boolean;
}

export function ForecastLegend({ showTotalRow, showStockStatus }: ForecastLegendProps) {
  return (
    <div className="flex flex-col gap-2 mt-4">
      <div className="flex items-center gap-4 text-xs text-muted-foreground">
        <div className="flex items-center gap-1">
          <div className="w-3 h-3 rounded bg-green-100 border border-green-200"></div>
          <span>Open PO (within firm boundary)</span>
        </div>
        <div className="flex items-center gap-1">
          <div className="w-3 h-3 rounded bg-blue-100 border border-blue-200"></div>
          <span>Forecast (Schedule Firm boundary)</span>
        </div>
        {showTotalRow && (
          <div className="flex items-center gap-1">
            <div className="w-3 h-3 rounded bg-purple-100 border border-purple-200"></div>
            <span>Total (Open PO + Forecast)</span>
          </div>
        )}
        <div className="flex items-center gap-1">
          <span className="text-red-600 font-semibold">Red</span>
          <span>= Arrears (past due)</span>
        </div>
      </div>
      {showStockStatus && <StockStatusLegend />}
    </div>
  );
}
